var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShopify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 26 29",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "shopify_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25.252v28.8H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shopify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.072 5.656a.277.277 0 00-.25-.232c-.104-.009-2.306-.172-2.306-.172l-1.697-1.687c-.168-.168-.496-.116-.624-.079l-.856.264C15.83 2.28 14.927.93 13.34.93c-.043 0-.088 0-.134.003-.45-.596-1.01-.855-1.492-.855-3.695 0-5.46 4.619-6.014 6.966l-2.586.803c-.802.25-.827.276-.933 1.031-.079.572-2.176 16.79-2.176 16.79l16.341 3.062 8.854-1.916S22.092 5.8 22.072 5.656zM15.436 4.03l-1.383.428.001-.299c0-.913-.127-1.649-.33-2.232.817.102 1.362 1.032 1.712 2.103zM12.71 2.108c.227.57.375 1.387.375 2.49v.16l-2.856.884c.55-2.122 1.58-3.147 2.481-3.534zm-1.098-1.04c.16 0 .32.055.474.16-1.184.558-2.453 1.962-2.99 4.764l-2.257.7c.628-2.138 2.119-5.623 4.773-5.623z",
    fill: "#95bf46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.822 5.424c-.104-.009-2.306-.172-2.306-.172l-1.698-1.687a.42.42 0 00-.236-.108l-1.235 25.272 8.853-1.915S22.092 5.8 22.072 5.656a.277.277 0 00-.25-.232z",
    fill: "#5e8e3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.34 10.316l-1.092 3.248s-.956-.511-2.129-.511c-1.719 0-1.805 1.079-1.805 1.35 0 1.484 3.866 2.052 3.866 5.526 0 2.734-1.733 4.494-4.071 4.494-2.805 0-4.24-1.746-4.24-1.746l.752-2.482s1.474 1.266 2.718 1.266c.813 0 1.144-.64 1.144-1.108 0-1.934-3.172-2.02-3.172-5.2 0-2.675 1.92-5.265 5.797-5.265 1.494 0 2.232.428 2.232.428z",
    fill: "#fff"
  }))));
}

export default SvgShopify;